// src/components/SightseeingBookingModal.js
import React, { useState, useEffect,useContext } from "react";
import {
  Modal,
  Offcanvas,
  Button,
  Form,
  Row,
  Col,
  Card,
  Image,InputGroup
} from "react-bootstrap";
import { Calendar, User, Phone } from "lucide-react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import initiateRazorpayPayment from '../components/Razorpay';
import { v4 as uuidv4 } from 'uuid';
import { db } from '../FireBase';
import { collection, addDoc, query, where, getDocs, limit, updateDoc ,  serverTimestamp,} from 'firebase/firestore';
import { AuthContext } from '../context/AuthContext';
import PaymentLoading from '../components/PaymentLoading';
import SuccessModal from "./SuccessModal";
import { useParams, useNavigate, useLocation } from 'react-router-dom';



const MOBILE_BREAKPOINT = 768;
const ACCENT = "#54b435";


// ------------------- Step Components -------------------
const Step1 = React.memo(({ selectedDate, setSelectedDate, name, setName, phone, setPhone, goNext, canProceedStep1 }) => {
  const today = new Date();
  return (
    <div className="text-center">
      <Form.Group className="mb-4 w-100 text-center">
        <Form.Label className="fw-semibold d-block mb-2">
          <Calendar className="me-2" size={18} /> Select Date
        </Form.Label>
        <div className="rounded shadow-sm p-2 bg-light d-inline-block">
          <DayPicker
            mode="single"
            selected={selectedDate}
            onSelect={setSelectedDate}
            disabled={{ before: today }}
          />
        </div>
      </Form.Group>

      <Form.Group className="mb-3 w-75 mx-auto">
         <Form.Label>Name</Form.Label>
         <InputGroup>
              <InputGroup.Text><User size={16} /></InputGroup.Text>
              <Form.Control
                type="text"
                name="name"
                value={name}
               onChange={(e) => setName(e.target.value)}
               
                placeholder="Enter guest name"
                required
               
              />
              </InputGroup>
      </Form.Group>

      <Form.Group className="mb-3 w-75 mx-auto">
       <Form.Label>Phone</Form.Label>
         <InputGroup>
                           <InputGroup.Text><Phone size={16} /></InputGroup.Text>
      <Form.Control
      type="tel"
      placeholder="Enter your phone number"
      value={phone}
   
      onChange={(e) => {
        let val = e.target.value;

        // Allow only "+" at the start and digits after
        if (val.startsWith("+")) {
          val = "+" + val.slice(1).replace(/[^0-9]/g, "");
        } else {
          val = val.replace(/[^0-9]/g, "");
        }

        // Limit to 13 characters max
        if (val.length > 13) val = val.slice(0, 13);

        setPhone(val);
      }}
      inputMode="numeric"
      pattern="^\\+?[0-9]{10,13}$" // optional +, 10–13 digits
      minLength={10}
      maxLength={13}
      required
    />
  </InputGroup>
      </Form.Group>

      

      <div className="d-flex justify-content-between mt-3">
        <div />
        <Button
          variant="success"
          onClick={goNext}
          disabled={!canProceedStep1}
          style={{ backgroundColor: ACCENT, borderColor: ACCENT }}
        >
          Next ➜
        </Button>
      </div>
    </div>
  );
});

const Step2 = React.memo(
  ({ vehicles, selectedVehicle, setSelectedVehicle, getPriceFor, goNext, goBack, loadingVehicles }) => {
    const skeletonArray = Array.from({ length: 3 });
    const ACCENT = "#28a745"; // Replace with your accent color or import if defined elsewhere

    // Track image loading states
    const [loadedImages, setLoadedImages] = useState({});

    const handleImageLoad = (id) => {
      setLoadedImages((prev) => ({ ...prev, [id]: true }));
    };

    return (
      <div>
        <div className="mb-3 text-center">
          <div className="fw-semibold mb-2">Choose a vehicle</div>
          <div className="text-muted" style={{ fontSize: 13 }}>
            Tap to select the vehicle for your sightseeing
          </div>
        </div>

        <div style={{ maxHeight: 390, overflowY: "auto" }}>
          {loadingVehicles ? (
            skeletonArray.map((_, i) => (
              <Card
                key={i}
                className="mb-3 shadow-sm p-2"
                style={{
                  borderRadius: "12px",
                  maxWidth: 520,
                  margin: "0 auto",
                  backgroundColor: "#e9ecef",
                  height: 90,
                  animation: "pulse 1.5s infinite",
                }}
              >
                <Row className="align-items-center g-2">
                  <Col xs={3}>
                    <div className="bg-light rounded" style={{ width: "100%", height: 74 }} />
                  </Col>
                  <Col xs={6}>
                    <div className="bg-light rounded mb-1" style={{ height: 16, width: "80%" }}></div>
                    <div className="bg-light rounded" style={{ height: 12, width: "50%" }}></div>
                  </Col>
                  <Col xs={3}>
                    <div className="bg-light rounded" style={{ height: 16, width: "100%" }}></div>
                  </Col>
                </Row>
              </Card>
            ))
          ) : vehicles.length === 0 ? (
            <p className="text-muted text-center">No vehicles available for this package.</p>
          ) : (
            vehicles.map((car) => {
              const selected = selectedVehicle === car.id;
              const price = getPriceFor(car.id);
              const isLoaded = loadedImages[car.id];

              return (
                <Card
                  key={car.id}
                  className={`mb-3 shadow-sm p-2 ${selected ? "border-2" : "border-0"}`}
                  style={{
                    cursor: "pointer",
                    borderRadius: "12px",
                    backgroundColor: selected ? "#e9f9ef" : "#ffffff",
                    borderColor: selected ? ACCENT : "transparent",
                    transition: "all 0.15s ease",
                    maxWidth: 520,
                    margin: "0 auto",
                  }}
                  onClick={() => setSelectedVehicle(car.id)}
                >
                  <Row className="align-items-center g-2">
                    <Col xs={3}>
                      <div style={{ position: "relative", width: "100%", height: 74 }}>
                        {!isLoaded && (
                          <div
                            className="bg-light rounded"
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              animation: "pulse 1.5s infinite",
                            }}
                          />
                        )}
                        <Image
                          src={car.image}
                          alt={car.name}
                          rounded
                          onLoad={() => handleImageLoad(car.id)}
                          style={{
                            width: "100%",
                            height: 74,
                            objectFit: "cover",
                            borderRadius: 15,
                            opacity: isLoaded ? 1 : 0,
                            transition: "opacity 0.3s ease",
                          }}
                        />
                      </div>
                    </Col>

                    <Col xs={6}>
                      <div className="fw-semibold" style={{ fontSize: 14 }}>
                        {car.name}
                      </div>
                      <div className="text-muted" style={{ fontSize: 12 }}>
                        Seats: {car.capacity}
                      </div>
                    </Col>

                    <Col xs={3} className="text-end">
                      {price !== null ? (
                        <div className="fw-bold" style={{ color: ACCENT }}>
                          ₹{price.toLocaleString("en-IN")}
                        </div>
                      ) : (
                        <div className="text-muted" style={{ fontSize: 12 }}>
                          Contact
                        </div>
                      )}
                    </Col>
                  </Row>
                </Card>
              );
            })
          )}
        </div>

        <div className="d-flex justify-content-between mt-3">
          <Button variant="light" onClick={goBack}>
            ← Back
          </Button>
          <Button
            variant="success"
            onClick={goNext}
            disabled={selectedVehicle === null}
            style={{ backgroundColor: ACCENT, borderColor: ACCENT }}
          >
            Next ➜
          </Button>
        </div>

        <style>
          {`
            @keyframes pulse {
              0% { opacity: 1; }
              50% { opacity: 0.4; }
              100% { opacity: 1; }
            }
          `}
        </style>
      </div>
    );
  }
);

const Step3 = React.memo(({ selectedCar, selectedPrice, pickup, setPickup, dropoff, setDropoff, goBack, setStep, initiatePayment, loadingPayment }) => (
  <div>
     
    <div className="mb-3">
      <div className="fw-semibold">Pickup & Drop</div>
      <div className="text-muted" style={{ fontSize: 13 }}>
        Enter pickup and drop locations only in kodaikanal city limits.
      </div>
    </div>

    <Form.Group className="mb-3">
      <Form.Label>Pickup Location</Form.Label>
      <Form.Control
        type="text"
        placeholder="e.g. Hotel ABC, Main Street"
        value={pickup}
        onChange={(e) => setPickup(e.target.value)}
         style={{width: '100%'}}
      />
    </Form.Group>

    <Form.Group className="mb-3">
      <Form.Label>Drop Location</Form.Label>
      <Form.Control
        type="text"
        placeholder="e.g. Museum XYZ, River Road"
        value={dropoff}
        onChange={(e) => setDropoff(e.target.value)}
         style={{width: '100%'}}
      />
    </Form.Group>

    <div className="p-3 my-3 rounded shadow-sm" style={{ background: "#fafbf9" }}>
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <div className="text-muted">Selected</div>
          <div className="fw-semibold">{selectedCar ? selectedCar.name : "-"}</div>
          <div style={{ fontSize: 13 }} className="text-muted">{selectedCar ? `Seats: ${selectedCar.capacity}` : ""}</div>
        </div>

        <div style={{ textAlign: "right" }}>
          <div className="text-muted">Price</div>
          <div className="fw-bold" style={{ color: ACCENT, fontSize: 18 }}>
            {selectedPrice !== null ? `₹${selectedPrice.toLocaleString("en-IN")}` : "Contact for price"}
          </div>
        </div>
      </div>
    </div>

    <div className="d-flex justify-content-between mt-3">
      <Button variant="light" onClick={goBack}>
        ← Back
      </Button>
      <div>
         <Button variant="light"onClick={() => setStep(1)}>
          Edit Date
        </Button>
        
       <Button
          className="success"
          style={{ backgroundColor: ACCENT, borderColor: ACCENT }}
          onClick={initiatePayment}
          disabled={!pickup || !dropoff || selectedPrice === null || loadingPayment}
        >
          {loadingPayment ? "Processing..." : `Pay ₹${selectedPrice !== null ? selectedPrice.toLocaleString("en-IN") : "-"}`}
        </Button>
      </div>
       
    </div>
  </div>
));

// ------------------- Main Modal Component -------------------
export default function SightseeingBookingModal({
  show,
  onHide,
  vehicles = [],
  vehiclePrices = {},
  onSubmit,
  onInitiatePayment,
  packageData,
}) {
  const [step, setStep] = useState(1);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [pickup, setPickup] = useState("");
  const [dropoff, setDropoff] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [loadingVehicles, setLoadingVehicles] = useState(true);
  const { currentUser } = useContext(AuthContext);
    const [orderPlaced, setOrderPlaced] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (vehicles.length > 0) {
      const timer = setTimeout(() => setLoadingVehicles(false), 800);
      return () => clearTimeout(timer);
    }
  }, [vehicles]);

  useEffect(() => {
    if (!show) {
      setStep(1);
      setSelectedDate(null);
      setSelectedVehicle(null);
      setName("");
      setPhone("");
      setPickup("");
      setDropoff("");
    }
  }, [show]);

  const getPriceFor = (id) => {
    const v = vehiclePrices?.[id];
    if (v === undefined || v === null) return null;
    const num = parseFloat(String(v).replace(/[^0-9.-]+/g, ""));
    return Number.isFinite(num) ? num : null;
  };

  const selectedPrice = getPriceFor(selectedVehicle);
  const selectedCar = vehicles.find((v) => v.id === selectedVehicle) || null;

  const canProceedStep1 = selectedDate && name.trim() && phone.trim();
  const canProceedStep2 = selectedVehicle !== null;

  const goNext = () => {
    if (step === 1 && !canProceedStep1) return;
    if (step === 2 && !canProceedStep2) return;
    setStep((s) => Math.min(3, s + 1));
  };
  const goBack = () => setStep((s) => Math.max(1, s - 1));

  const handlePaymentSuccess = (paymentResult) => {
    const bookingData = {
      date: selectedDate,
      vehicle: selectedVehicle,
      name: name.trim(),
      phone: phone.trim(),
      pickup: pickup.trim(),
      dropoff: dropoff.trim(),
      price: selectedPrice,
      payment: paymentResult || { status: "success", id: "SIMULATED" },
    };

    if (typeof onSubmit === "function") {
      try {
        onSubmit(bookingData);
      } catch (err) {
        console.error(err);
      }
    }

    setLoadingPayment(false);
    onHide();
  };

  const handlePaymentFailure = (err) => {
    console.error("Payment failed:", err);
    setLoadingPayment(false);
    alert("Payment failed. Please try again.");
  };


      const formatDateForOrder = (date) => {
    return date?.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };
  const initiatePayment = async () => {
    const selectedCarObj = vehicles.find((v) => v.id === selectedVehicle) || null;
    const orderId = 'KABSS' + uuidv4().slice(0, 8).toUpperCase();
    const transactionId = 'TR' + Date.now().toString().slice(-6);
    const bookingData = {
      date: formatDateForOrder(selectedDate),
      vehicleDetails: selectedCarObj,
      name: name.trim(),
      phone: phone.trim(),
      pickup: pickup.trim(),
      dropoff: dropoff.trim(),
      price: selectedPrice,
      packageName: packageData.name || null,
      packageId: packageData.id || null,
      paymentStatus:"Pending",
      orderId,
      status: "payment-pending",
      transactionId,
      userId: currentUser?.cusmid || null,
      createdAt: serverTimestamp(),
      paymentMethod: 'Razorpay',
    };

    const transactionData = {
      userId: currentUser.cusmid,
      orderId,
      transactionId,
      paymentAmount: selectedPrice,
      paymentDate: serverTimestamp(),
      type: 'SIGHT_SEEING',
    };

    console.log("Initiating payment with data:", bookingData);
    try {
      onHide();
      setLoadingPayment(true);

            await addDoc(collection(db, 'slightSeeing_booking'), bookingData);
            await addDoc(collection(db, 'transactions'), transactionData);
        
            let razorpayId ='' 

              const success = await initiateRazorpayPayment(selectedPrice, transactionId, currentUser.phoneNumber,orderId);
              if (!success) throw new Error('Payment failed');
              razorpayId=success.razorpay_payment_id;
              console.log("payment rec")
                const q = query(
              collection(db, "transactions"),
              where("orderId", "==", orderId),
              limit(1)
            );
            const snap = await getDocs(q);
            if (!snap.empty) {
              await updateDoc(snap.docs[0].ref, {
                razorpayId,
                status: "paid",

              });
              setOrderPlaced(true);
            }
            
         setTimeout(() => {
          setLoadingPayment(false);
          setOrderPlaced(true);  
      }, 800);
    } catch (err) {
      handlePaymentFailure(err);
    }
  };

  const StepIndicator = () => (
    <div style={{ marginBottom: 16 }}>
      <div className="d-flex justify-content-between align-items-center">
        {[1, 2, 3].map((i) => {
          const labels = ["Date & Guest", "Choose Vehicle", "Pickup / Pay"];
          const active = step === i;
          const done = step > i;
          return (
            <div key={i} className="text-center" style={{ flex: 1 }}>
              <div
                style={{
                  width: 36,
                  height: 36,
                  lineHeight: "36px",
                  borderRadius: 18,
                  margin: "0 auto",
                  background: done ? ACCENT : active ? ACCENT : "#e9ecef",
                  color: done || active ? "white" : "#6c757d",
                  fontWeight: 700,
                }}
              >
                {i}
              </div>
              <div style={{ marginTop: 6, fontSize: 12, color: "#495057" }}>{labels[i - 1]}</div>
            </div>
          );
        })}
      </div>
    </div>
  );

  const content = (
    <Form onSubmit={(e) => e.preventDefault()}>
      <StepIndicator />
      {step === 1 && (
        <Step1
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          name={name}
          setName={setName}
          phone={phone}
          setPhone={setPhone}
          goNext={goNext}
          canProceedStep1={canProceedStep1}
        />
      )}
      {step === 2 && (
        <Step2
          vehicles={vehicles}
          selectedVehicle={selectedVehicle}
          setSelectedVehicle={setSelectedVehicle}
          getPriceFor={getPriceFor}
          goNext={goNext}
          goBack={goBack}
          loadingVehicles={loadingVehicles}
        />
      )}
      {step === 3 && (
        <Step3
          selectedCar={selectedCar}
          selectedPrice={selectedPrice}
          pickup={pickup}
          setPickup={setPickup}
          dropoff={dropoff}
          setDropoff={setDropoff}
          goBack={goBack}
          setStep={setStep}
          initiatePayment={initiatePayment}
          loadingPayment={loadingPayment}
        />
      )}
    </Form>
    
  );


return (
  <>
    {isMobile ? (
     <Offcanvas
      show={show}
      onHide={onHide}
      placement="bottom"
      style={{ borderTopLeftRadius: 20, borderTopRightRadius: 20, height: "auto" }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="fw-bold fs-5">Book Sightseeing</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>{content}</Offcanvas.Body>
    </Offcanvas>
    ) : (
       <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title className="fw-bold">Book Sightseeing</Modal.Title>
      </Modal.Header>
      <Modal.Body>{content}</Modal.Body>
    </Modal>
    )}

    {/* Global Overlays */}
    {loadingPayment && <PaymentLoading show />}
    {orderPlaced && <SuccessModal show onClose={() => navigate('/')} />}
  </>
)}